import React, { useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.status === 429) {
        setError('Trop de demandes. Réessayez dans une heure.');
        setLoading(false);
        return;
      }
      // Réponse neutre quel que soit le résultat (anti-énumération)
      setSubmitted(true);
    } catch (_) {
      // Même en cas d'erreur réseau, on reste neutre
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#0F172A] flex items-center justify-center p-4"
      data-testid="forgot-password-page"
    >
      <div className="w-full max-w-md">
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 shadow-2xl">
          {!submitted ? (
            <>
              <div className="text-center mb-6">
                <i className="bi bi-key text-3xl text-blue-300"></i>
                <h1 className="text-xl font-bold text-white mt-3">Mot de passe oublié</h1>
                <p className="text-sm text-slate-300 mt-2">
                  Saisissez votre email : si un compte existe, vous recevrez un lien de réinitialisation.
                </p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-5">
                {error && (
                  <div
                    className="bg-red-500/20 border border-red-500/50 rounded-lg p-3 text-red-200 text-sm flex items-center gap-2"
                    data-testid="forgot-error"
                  >
                    <i className="bi bi-exclamation-triangle"></i>
                    {error}
                  </div>
                )}
                <div>
                  <label className="block text-sm font-medium text-slate-200 mb-2">Email</label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-4 text-slate-300">
                      <i className="bi bi-envelope"></i>
                    </span>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full bg-white/10 border border-white/20 rounded-xl py-3 pl-12 pr-4 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                      placeholder="votre@email.fr"
                      required
                      data-testid="forgot-email"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#0062CC] hover:bg-[#0056b3] text-white font-semibold py-3 px-4 rounded-xl transition disabled:opacity-50 flex items-center justify-center gap-2"
                  data-testid="forgot-submit"
                >
                  {loading ? (
                    <><i className="bi bi-arrow-repeat animate-spin"></i> Envoi...</>
                  ) : (
                    <>Envoyer le lien</>
                  )}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center py-4" data-testid="forgot-success">
              <i className="bi bi-envelope-check text-4xl text-emerald-400"></i>
              <h1 className="text-xl font-bold text-white mt-3">Vérifiez votre boîte mail</h1>
              <p className="text-sm text-slate-300 mt-2">
                Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.
                Le lien est valable 1 heure.
              </p>
            </div>
          )}
          <div className="mt-6 text-center">
            <a
              href="/login"
              className="text-sm text-slate-300 hover:text-white underline-offset-2 hover:underline transition"
              data-testid="forgot-back-to-login"
            >
              <i className="bi bi-arrow-left mr-1"></i> Retour à la connexion
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
